import { Native } from '@hb/mbridge';
import { showThirdPage } from './jumpUrl';
import { isHelloFamilyApp } from '../env/env';

export default class JumpMarket {
  static listenH5BackToH5(callback: { (): void }) {
    // eslint-disable-next-line no-nested-ternary
    const hiddenProperty = 'hidden' in window.document ? 'hidden' : ('webkitHidden' in document ? 'webkitHidden' : 'mozHidden' in document ? 'mozHidden' : '');
    const toExcuteFunc = () => {
      if (!document[hiddenProperty]) {
        // 当从原生页面用户一系列操作后,返回H5的时候,这里会被触发
        callback();
        window.removeEventListener('pageshow', toExcuteFunc);
      }
    };
    // TODO: 部分机型不支持pageshow事件
    window.addEventListener('pageshow', toExcuteFunc);
  }

  static showBar() {
    if (isHelloFamilyApp) {
      Native.toggleNavBar({ isShow: true });
      Native.callNative({ classMap: 'NavBar', method: 'setStatusBar', params: { isShowStatusBar: true } });
    }
  }

  static hideBar() {
    if (isHelloFamilyApp) {
      Native.toggleNavBar({ isShow: false });
      Native.callNative({ classMap: 'NavBar', method: 'setStatusBar', params: { isShowStatusBar: false } });
    }
  }

  /**
   * 第三方页面跳转
   * @param targetUrl 跳转的链接
   * @param cooperateBar 是否需要双向操作标题栏
   * @param showTargetBar 是否展示跳转页面的标题栏
   */
  static goPage(targetUrl: string, cooperateBar = true, showTargetBar = true) {
    showThirdPage(targetUrl);

    if (cooperateBar) {
      if (showTargetBar) {
        JumpMarket.showBar();
      }

      JumpMarket.listenH5BackToH5(() => {
        JumpMarket.hideBar();
      });
    }
  }
}
